import IpubDateRangePicker from './src/main'

/* istanbul ignore next */
IpubDateRangePicker.install = function(Vue) {
  Vue.component(IpubDateRangePicker.name, IpubDateRangePicker)
}

export default IpubDateRangePicker
